<template>
    <side-container v-if="visible"
        :width="450"
        :headerTitle="headerTitle"
        :isShowFooterBtn="false"
        :isLoading="isLoading"
        @close="$emit('update:visible', false)">
        <div class="body">
            <div class="title-wrapper fx-v-center fx-h-between fs-14">
                <p class="fw-600">充值送规则<span class="fs-12 fw-400 color-999">（最多{{ maxGrade }}级）</span></p>
                <button v-if="levels.length < maxGrade"
                    class="text-btn pr-0"
                    @click="addLevel">+添加档位</button>
            </div>
            <div class="level-wrapper">
                <template v-if="levels.length > 0">
                    <div v-for="(item, index) in levels"
                        :key="index"
                        class="level pt-12 pb-12">
                        <div class="fx-v-center fx-h-between">
                            <span class="fs-16 fw-600">充值档位{{ index + 1 }}</span>
                            <del-popover v-if="levels.length > 1"
                                :msg="'确定删除此档位吗？'"
                                @confirmFn="delConfirm(index)">
                                <button class="text-btn color-red fs-14 pr-0"
                                    slot="refer">删除</button>
                            </del-popover>
                        </div>
                        <div class="fx level-inner mt-8">
                            <div class="fx threshold-wrapper"
                                :class="{
                                    'is-error': item.isThresholdError !== -1,
                                    'is-error-zero': item.isThresholdError === 0,
                                    'is-error-up': item.isThresholdError === 1,
                                    'is-error-down': item.isThresholdError === 2
                                }">
                                <span class="des">充值满：</span>
                                <el-input v-model="item.threshold"
                                    placeholder="请输入"
                                    @input="handleIpt(item, 'threshold', index)">
                                    <span slot="suffix" class="color-333">元</span>
                                </el-input>
                            </div>
                            <div class="fx ml-20 bonus-wrapper"
                                :class="{
                                    'is-error': item.isBonusError !== -1,
                                    'is-error-zero': item.isBonusError === 0,
                                    'is-error-up': item.isBonusError === 1,
                                    'is-error-down': item.isBonusError === 2
                                }">
                                <span class="des">赠送余额：</span>
                                <el-input v-model="item.bonus_amount"
                                    placeholder="请输入"
                                    @input="handleIpt(item, 'bonus_amount', index)">
                                    <span slot="suffix" class="color-333">元</span>
                                </el-input>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <p class="mt-20 color-999 fs-12 align-c">暂无档位</p>
                </template>
            </div>
            <div class="title-wrapper fx-v-center fx-h-between fs-14">
                <p class="fw-600">充值送设置</p>
            </div>
            <div class="config fx-v-center mt-12">
                <span class="mr-20">自定义金额充值</span>
                <el-switch v-model="isSetCashCustom"
                    active-color="#009688"
                    inactive-color="#ddd"/>
            </div>
        </div>
        <!--  footer  -->
        <div
            class="footer"
            slot="footer">
            <div
                class ="btn-wrapper"
                :class="mode">
                <el-button
                    size="medium"
                    type="primary"
                    :loading="isConfirmLoading"
                    :disabled="!canConfirm"
                    @click="confirmClick"
                >确认</el-button>
            </div>
        </div>
    </side-container>
</template>

<script lang='ts'>
import { createComponent, ref, SetupContext, computed, watch } from '@vue/composition-api'
import SideContainer from '@/components/layout/side-container-style2.vue'
import DelPopover from '@/components/del_popover/del_popover.vue'
import { inputLimit } from '@/utils'
import { openMessage } from '../../../../utils/system'
import $fetch from '../../../../api'
import { OldLevels } from './recharge_delivery_table.vue'
import debounce from 'lodash/debounce'
import { inputValider } from '@/utils'

interface Level {
    threshold: number | string
    bonus_amount: number | string
    isThresholdError: number
    isBonusError: number
}

interface NormalLevel {
    threshold: number
    bonus_amount: number
}

type NormalLevels = NormalLevel[]

type IptType = 'threshold' | 'bonus_amount'

export type Levels = Level[]

export default createComponent({
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        mode: {
            type: String,
            required: true
        },
        oldLevels: {
            type: Array,
            default: () => []
        },
        activityId: {
            type: Number
        },
        customRecharge: {
            type: Number
        },
        confirmCallback: {
            type: Function
        }
    },

    setup(
        props: {
            visible: boolean,
            mode: string,
            oldLevels: OldLevels,
            activityId: number,
            customRecharge: number,
            confirmCallback?: () => void
        },
        ctx: SetupContext
    ) {
        const isLoading = ref(false)
        const isConfirmLoading = ref(false)
        const isSetCashCustom = ref(false)
        // const isIpt = ref(false)
        const maxGrade = ref(4)
        const levels = ref<Levels>([])

        const iptTypeArr: IptType[] = ['threshold', 'bonus_amount']
        const iptTypeObj = {
            threshold: 'isThresholdError',
            bonus_amount: 'isBonusError'
        }
        // const zeroReg = /^0+\.?0*$/
        const numberReg = /^\d{0,4}(\.\d{0,2})?$/
        // const numberLimit = inputLimit(numberReg)
        // const debounceIptHandler = debounce(iptHandler, 500)
        const {
            isIpt,
            delConfirm,
            handleIpt
        } = inputValider(levels, iptTypeObj, numberReg)

        watch(() => props.visible, (newVal: boolean) => {
            if (newVal) {
                isSetCashCustom.value = props.customRecharge === 1 ? true : false
                levels.value = []
                judgeMode()
            }
        })

        const canConfirm = computed(() => {
            return !isIpt.value && levels.value.every((level: Level) => level.threshold !== '' && level.bonus_amount !== '' && level.isThresholdError === -1 && level.isBonusError === -1)
        })

        const headerTitle = computed(() => {
            switch (props.mode) {
                case 'create':
                    return '设置充值送'
                case 'update':
                    return '编辑充值送'
                default:
                    return '未知标题'
            }
        })

        function judgeMode() {
            switch (props.mode) {
                case 'create':
                    break
                case 'update':
                    levels.value = props.oldLevels.map(l => {
                        const newL = {
                            ...l,
                            isThresholdError: -1,
                            isBonusError: -1
                        }

                        return newL
                    })
                    break
                default:
                    break
            }
        }

        // function handleIpt(item: Level, type: IptType, index: number) {
        //     !isIpt.value && (isIpt.value = true)
        //     numberLimit(item, type)
        //     debounceIptHandler(...arguments)
        // }

        // function iptHandler(item: Level, type: IptType, index: number) {
        //     findError(item, type, index)
        //     isIpt.value && (isIpt.value = false)
        // }

        // function findError(item: Level, type: IptType, index: number) {
        //     const curLevels = levels.value
        //     const lastL = curLevels[index - 1]
        //     const nextL = curLevels[index + 1]
        //     item[iptTypeObj[type]] = -1
        //     const zeroFlag = findZeroError(item, type)
        //     if (zeroFlag) {
        //         return
        //     }
        //     findNextError(item, nextL, type)
        //     findLastError(item, lastL, type)
        // }

        // function findZeroError(l: Level, type: IptType) {
        //     if (zeroReg.test(l[type] as string)) {
        //         l[iptTypeObj[type]] = 0
        //         return true
        //     } else {
        //         return false
        //     }
        // }

        // function findLastError(l: Level, lastL: Level | undefined, type: IptType) {
        //     if (lastL == null) {
        //         return
        //     }
        //     if (l[type] === '' || lastL[type] === '') {
        //         if (lastL[iptTypeObj[type]] === 2) {
        //             lastL[iptTypeObj[type]] = -1
        //         }
        //         return
        //     }
        //     if (+l[type] <= +lastL[type]) {
        //         l[iptTypeObj[type]] = 1
        //     } else {
        //         if (lastL[iptTypeObj[type]] === 2) {
        //             lastL[iptTypeObj[type]] = -1
        //         }
        //     }
        // }

        // function findNextError(l: Level, nextL: Level | undefined, type: IptType) {
        //     if (nextL == null) {
        //         return
        //     }
        //     if (l[type] === '' || nextL[type] === '') {
        //         if (nextL[iptTypeObj[type]] === 1) {
        //             nextL[iptTypeObj[type]] = -1
        //         }
        //         return
        //     }
        //     if (+l[type] >= +nextL[type]) {
        //         l[iptTypeObj[type]] = 2
        //     } else {
        //         if (nextL[iptTypeObj[type]] === 1) {
        //             nextL[iptTypeObj[type]] = -1
        //         }
        //     }
        // }

        function close() {
            ctx.emit('update:visible', false)
        }

        function addLevel() {
            levels.value.push({
                threshold: '',
                bonus_amount: '',
                isThresholdError: -1,
                isBonusError: -1
            })
        }

        // function delConfirm(index: number) {
        //     const curLevels = levels.value
        //     const lastL = curLevels[index - 1]
        //     const nextL = curLevels[index + 1]
        //     curLevels.splice(index, 1)
        //     iptTypeArr.forEach(iptType => {
        //         if (lastL != null) {
        //             findError(lastL, iptType, index - 1)
        //         } else {
        //             findError(nextL, iptType, index)
        //         }
        //     })
        // }

        function filterLevels(ls: Levels) {
            const arr: NormalLevels = []
            ls.forEach(l => (
                arr.push({
                    threshold: +l.threshold,
                    bonus_amount: +l.bonus_amount
                })
            ))

            return arr
        }

        function confirmClick() {
            switch (props.mode) {
                case 'create':
                    createRechargeBonus()
                    break
                case 'update':
                    updateRechargeBonus()
                    break
                default:
                    break
            }
        }

        async function createRechargeBonus() {
            try {
                isConfirmLoading.value = true
                await $fetch.post({
                    url: '/activity/createrechargebonus',
                    params: {
                        cashier_custom_recharge: isSetCashCustom.value ? 1 : 0,
                        levels: filterLevels(levels.value)
                    }
                })
                openMessage('success', '创建成功')
                close()
                props.confirmCallback && props.confirmCallback()
            } catch (e) {
                openMessage('error', e.message || '创建失败')
            } finally {
                isConfirmLoading.value = false
            }
        }

        async function updateRechargeBonus() {
            try {
                isConfirmLoading.value = true
                await $fetch.post({
                    url: '/activity/updaterechargebonus',
                    params: {
                        activity_id: props.activityId,
                        cashier_custom_recharge: isSetCashCustom.value ? 1 : 0,
                        levels: filterLevels(levels.value)
                    }
                })
                openMessage('success', '更新成功')
                close()
                props.confirmCallback && props.confirmCallback()
            } catch (e) {
                openMessage('error', e.message || '更新失败')
            } finally {
                isConfirmLoading.value = false
            }
        }

        return {
            // data
            isLoading,
            isConfirmLoading,
            isSetCashCustom,
            maxGrade,
            levels,
            // computed
            canConfirm,
            headerTitle,
            // methods
            handleIpt,
            confirmClick,
            addLevel,
            delConfirm
        }
    },
    components: {
        SideContainer,
        DelPopover
    }
})
</script>

<style lang="scss" scoped>
.body {
    padding: 0 12px;
    font-size: 14px;
    color: #333;

    .level-wrapper {
        .level {
            box-sizing: border-box;
            border-bottom: 1px solid #ebebeb;

            &:last-child {
                border-bottom: none !important;
            }

            .level-inner {
                > div {
                    flex: 1;

                    .des {
                        flex: none;
                        height: 40px;
                        line-height: 40px;
                    }

                    ::v-deep .el-input {
                        .el-input__inner {
                            padding-left: 8px;
                        }
                    }

                    &.threshold-wrapper.is-error,
                    &.bonus-wrapper.is-error {
                        ::v-deep .el-input {
                            position: relative;
                            padding-bottom: 24px;

                            &::before {
                                content: '';
                                position: absolute;
                                left: 0;
                                bottom: 0;
                                line-height: 20px;
                                font-size: 12px;
                                color: #E51C23;
                            }

                            .el-input__inner {
                                border-color: #E51C23 !important;
                            }
                        }
                    }

                    &.threshold-wrapper.is-error {
                        &.is-error-up {
                            ::v-deep .el-input::before {
                                content: '充值金额需高于上一档位';
                            }
                        }

                        &.is-error-down {
                            ::v-deep .el-input::before {
                                content: '充值金额需低于下一档位';
                            }
                        }

                        &.is-error-zero {
                            ::v-deep .el-input::before {
                                content: '充值金额不能为0';
                            }
                        }
                    }

                    &.bonus-wrapper.is-error {
                        &.is-error-up {
                            ::v-deep .el-input::before {
                                content: '赠送余额需高于上一档位';
                            }
                        }

                        &.is-error-down {
                            ::v-deep .el-input::before {
                                content: '赠送余额需低于下一档位';
                            }
                        }

                        &.is-error-zero {
                            ::v-deep .el-input::before {
                                content: '赠送余额不能为0';
                            }
                        }
                    }
                }
            }
        }
    }

    .title-wrapper {
        margin-top: 20px;

        p {
            position: relative;
            padding-left: 8px;
            line-height: 20px;

            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                width: 4px;
                height: 20px;
                border-radius: 2px;
                background-color: #009688;
            }
        }
    }
}

.footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 7px 12px;
}
</style>
